import { PerDiemRatesFormFragment } from 'generated/resources/graphql'

export const getPerDiemRatesDefaultValues = (data?: PerDiemRatesFormFragment | null) => {
  const perDiemRates = data?.perDiem?.perDiemRates

  const rates =
    perDiemRates && perDiemRates.length > 0
      ? perDiemRates.map((rate) => ({
          id: rate.id,
          rateConfigurationId:
            rate.rateConfiguration?.id === '-1' ? null : rate.rateConfiguration?.id,
          units: rate.totalDays || 1,
          totalAmount: rate.totalAmountCents || 0,
          rateAmount: rate.rateConfiguration?.amountCents || 0,
          label: rate.rateConfiguration?.name || '',
          currency: rate.rateConfiguration?.currency || data?.currency || 'EUR',
        }))
      : [
          {
            id: null,
            rateConfigurationId: null,
            units: 1,
            totalAmount: 0,
            rateAmount: 0,
            label: '',
            currency: data?.currency || 'EUR',
          },
        ]

  return {
    currency: data?.currency || 'EUR',
    deleted_rates: [],
    perDiemRates: rates,
  }
}
